import { useEffect, useRef, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import useActiveNavbar from "../hook/useActiveNavbar";

const Header = () => {
    const navigate = useNavigate();
    const [navbarHeader, setNavbarHeader] = useState<any[]>([
        {
            name: "Home",
            link: "/",
            isChildVisible: false,
            child: []
        },
        {
            name: "Tutorial",
            link: "/tutorial",
            isChildVisible: false,
            child: []
        },
        {
            name: "Features",
            link: "/features",
            isChildVisible: false,
            child: []
        },
        {
            name: "Resources",
            link: "",
            isChildVisible: false,
            child: [
                {
                    name: "Security",
                    link: "/security",
                },
                {
                    name: "Demos",
                    link: "/demos",
                },
                {
                    name: "Blog",
                    link: "/blog",
                },
                {
                    name: "Contact Us",
                    link: "/contact-us",
                }
            ]
        },
        {
            name: "FAQ",
            link: "/faq",
            isChildVisible: false,
            child: []
        },
        {
            name: "Pricing",
            link: "/pricing",
            isChildVisible: false,
            child: []
        }
    ]);
    const { selected, setSelected }: any = useActiveNavbar();
    const [isSidebarOpen, setSidebarOpen] = useState(false);
    const [openDropdown, setOpenDropdown] = useState<any | null>(null);
    const mobileViewRef = useRef<HTMLDivElement>(null);
    const dropdownRef = useRef<HTMLButtonElement[]>([]);

    useEffect(() => {
        if (isSidebarOpen) {
            document.body.classList.add("overflow-hidden");
        } else {
            document.body.classList.remove("overflow-hidden");
        }

        return () => document.body.classList.remove("overflow-hidden");
    }, [isSidebarOpen]);

    const linkClasses = ({ isActive }: { isActive: boolean }) =>
        `text-sm hover:text-secondary ${isActive ? "text-secondary font-medium" : "text-blackRgba"
        }`;


    useEffect(() => {
        const handleDropDown = (e: MouseEvent) => {
            if (!mobileViewRef.current?.contains(e.target as Node)) {

                const clickedInsideDropdown = dropdownRef.current.some(
                    (ref) => ref?.contains(e.target as Node)
                );

                if (!clickedInsideDropdown) {
                    setNavbarHeader((prevNavbar) =>
                        prevNavbar.map((item) => ({
                            ...item,
                            isChildVisible: false
                        }))
                    );
                }
            }
        };

        document.addEventListener("click", handleDropDown);

        return () => {
            document.removeEventListener("click", handleDropDown);
        };
    }, []);



    const location = useLocation();
    const hideHeaderForAdmin = "admin";
    const hideHeaderForMember = "member";
    const hideHeaderForSuperAdmin = "superadmin";
    const hideHeaderForPageNotFound = "not-found";
    const hideHeaderForUnAuthorised = "un-authorized";
    const hideHeaderForDoc = "docs";
    const hideHeaderForHelp = "tutorial";
    const hideHeaderForVisitor = "/public/register";
    if (location.pathname.replace("/", "").startsWith(hideHeaderForAdmin)
        || location.pathname.replace("/", "").startsWith(hideHeaderForMember)
        || location.pathname.replace("/", "").startsWith(hideHeaderForSuperAdmin)
        || location.pathname.replace("/", "").includes(hideHeaderForPageNotFound)
        || location.pathname.replace("/", "").includes(hideHeaderForUnAuthorised)
        || location.pathname.replace("/", "").includes(hideHeaderForDoc)
        || location.pathname.replace("/", "").includes(hideHeaderForHelp)
        || location.pathname.startsWith(hideHeaderForVisitor)
    ) {
        return <></>;
    }

    return (
        <>
            <nav className="sticky px-4 md:px-[46px] py-[10px] top-0 z-[50] bg-white shadow-sm">
                <div className="w-full flex items-center justify-between">
                    <NavLink to="/">
                        <img
                            className="logo-img lg:w-[186px] w-[120px] h-auto"
                            src="/images/navbar_logo.png"
                            alt="logo"
                        />
                    </NavLink>

                    <div className="hidden lg:flex items-center gap-6">
                        {navbarHeader.map((item, index) =>
                            item.child.length === 0 ? (
                                <NavLink
                                    key={index}
                                    to={item.link}
                                    className={linkClasses}
                                    onClick={() => setSelected(item.link)}
                                >
                                    {item.name}
                                </NavLink>
                            ) : (
                                <div key={index} className="relative group inline-block">
                                    <button className="flex items-center text-sm gap-1 text-blackRgba">
                                        <span className={`text-sm hover:text-secondary ${item.child.some((c: any) => c.link === selected)
                                            ? "text-secondary font-medium"
                                            : "text-blackRgba"
                                            }`}>
                                            {item.name}
                                        </span>
                                        <span className="material-symbols-outlined">
                                            keyboard_arrow_down
                                        </span>
                                    </button>


                                    <div className="absolute top-full left-0 invisible group-hover:visible opacity-0 group-hover:opacity-100 transition shadow-lg rounded-md z-10 bg-white">
                                        <ul className="min-w-[180px] py-2">
                                            {item.child.map((child: any, i: number) => (
                                                <li
                                                    key={i}
                                                    className={`px-4 py-2 text-sm hover:bg-gray-100 whitespace-nowrap ${selected === child.link
                                                        ? "text-secondary font-medium"
                                                        : "text-blackRgba"
                                                        }`}
                                                >
                                                    <NavLink
                                                        to={child.link}
                                                        className="block w-full"
                                                        onClick={() => setSelected(child.link)}
                                                    >
                                                        {child.name}
                                                    </NavLink>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            )
                        )}
                    </div>

                    <div className="hidden lg:flex items-center gap-2.5">
                        <button
                            className="px-5 py-[6px] bg-transparent text-sm border-2 border-secondary text-secondary font-medium rounded-[8px] hover:shadow-md hover:opacity-90"
                            onClick={() => navigate("/sign-in")}
                        >
                            Sign In
                        </button>

                        <button
                            className="px-5 py-[6px] bg-secondary text-sm text-white font-medium rounded-[8px] hover:shadow-md hover:opacity-90"
                            onClick={() => navigate("/free-trial")}
                        >
                            Get Started Free
                        </button>
                    </div>

                    <button
                        className="lg:hidden block"
                        onClick={() => setSidebarOpen(!isSidebarOpen)}
                    >
                        <span className="material-symbols-outlined text-3xl">
                            menu
                        </span>
                    </button>
                </div>
            </nav>

            <div className={`fixed top-0 left-0 w-full overflow-auto h-screen overflow-y-auto px-2 bg-white z-50 shadow-lg transform transition-transform duration-300 ease-in-out ${isSidebarOpen ? "translate-x-0" : "-translate-x-full"}`}>
                <div className="flex justify-end items-center p-2 border-b">
                    <button
                        onClick={() => setSidebarOpen(false)}
                    >
                        <span className="material-symbols-outlined text-2xl">
                            close
                        </span>
                    </button>
                </div>


                <div className="p-4 space-y-2">
                    {navbarHeader.map((item, index) =>
                        item.child.length === 0 ? (
                            <div key={index}>
                                <NavLink
                                    to={item.link}
                                    className={linkClasses}
                                    onClick={() => {
                                        setSelected(item.link);
                                        setSidebarOpen(false);
                                        setOpenDropdown(false);
                                    }}
                                >
                                    {item.name}
                                </NavLink>
                            </div>

                        ) : (
                            <div key={index}>
                                <button
                                    className={`flex items-center text-sm ${item.child.some((c: any) => c.link === selected)
                                        ? "text-secondary font-medium"
                                        : "text-blackRgba"
                                        }`}
                                    onClick={() =>
                                        setOpenDropdown(
                                            openDropdown === index ? null : index
                                        )
                                    }
                                >
                                    {item.name}
                                    <span className="material-symbols-outlined">
                                        expand_more
                                    </span>
                                </button>

                                {openDropdown === index && (
                                    <div className="ml-4 mt-2 flex flex-col gap-2">
                                        {item.child.map((child: any, i: number) => (
                                            <NavLink
                                                key={i}
                                                to={child.link}
                                                className={`px-4 py-2 text-sm whitespace-nowrap ${selected === child.link
                                                    ? "text-secondary font-medium"
                                                    : "text-blackRgba"
                                                    }`}
                                                onClick={() => {
                                                    setSelected(child.link);
                                                    setSidebarOpen(false);
                                                }}
                                            >
                                                {child.name}
                                            </NavLink>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )
                    )}
                </div>

                <div className="flex flex-col gap-3 mt-4">

                    <button
                        className="px-5 py-[6px] bg-transparent text-sm border-2 border-secondary text-secondary font-medium rounded-[8px] hover:shadow-md hover:opacity-90"
                        onClick={() => {
                            setSidebarOpen(false);
                            navigate("/sign-in");
                        }}
                    >
                        Sign In
                    </button>

                    <button
                        className="px-5 py-[6px] bg-secondary text-sm text-white font-medium rounded-[8px] hover:shadow-md hover:opacity-90"
                        onClick={() => {
                            setSidebarOpen(false);
                            navigate("/free-trial");
                        }}
                    >
                        Get Started Free
                    </button>

                </div>
            </div>

            {
                isSidebarOpen && (
                    <div
                        className="fixed inset-0 bg-black bg-opacity-50 z-40"
                        onClick={() => setSidebarOpen(false)}
                    />
                )
            }
        </>
    );
}

export default Header; 